<template>
  <v-container class="pa-10">
    <v-container>
      <div class="text-h5">Provas e concursos</div>
      <v-divider />
      <div class="text-h7">
        Temos uma lista com provas de concursos com seus gabaritos para lhe ajudar
        a se preparar ainda mais. Caso não encontre alguma prova no link abaixo,
        deixe um recado no Fale Conosco. <br/>
        <a href="https://www.dropbox.com/sh/k5490q4qt2iouif/AAA__xaTVpKeqRTWz1vW8NkRa?dl=0">Clique aqui para ser redirecionado para nosso banco de provas.</a>
      </div>
    </v-container>

<!--
    <v-row no-gutters>
      <v-col cols="12">
        <v-data-table
          :loading="isLoading"
          :headers="headers"
          :items="lstProvasPorProduto"
          :search="search"
          :custom-filter="filterOnlyCapsText"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-col md="5" sm="12" class="pa-0">
                <v-text-field
                  v-model="search"
                  prepend-inner-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>

          <template v-slot:[`item.acao`]="{ item }">
            <v-icon small class="mr-2" @click="download(item)"
              >mdi-download</v-icon
            >
          </template>
        </v-data-table>
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
  import Headers from  '../../components/jsonsHelper/headers'
  import { mapActions, mapState } from 'vuex'

  export default {
    data: () => ({
      search: '',
      header: ''
    }),

    computed: {
      ...mapState('prova', ['lstProvasPorProduto', 'isLoading'])
    },

    created() {
      this.initialize();
    },
    methods: {
      ...mapActions('prova', ['getProvaListProduto','updateProva']),
      initialize() {
        this.headers = Headers.provaConcursoHeaders
        var user
        if (localStorage.getItem('auth.currentUser')) {
          user = JSON.parse(localStorage.getItem('auth.currentUser'));
        }
        if (user.perfil.id == 1){
          this.getProvaListProduto(null)

        }else{
          this.getProvaListProduto({idResidencia: user.assinaturasList[0].plano.idResidencia})
        }
      },

      filterOnlyCapsText(value, search) {
        search = search.toString().toLocaleUpperCase();
        return (
          value != null &&
          search != null &&
          typeof value === 'string' &&
          value
            .toString()
            .toLocaleUpperCase()
            .indexOf(search) !== -1
        );
      },
      download(item) {
        var AWS = require('aws-sdk');
        AWS.config.update({
          accessKeyId: "AKIAUTBRXH4JR2WUCFJW",
          secretAccessKey: "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",
          region: "sa-east-1"
        });
        var s3 = new AWS.S3();
        s3.getObject({ Bucket: 'medcof-provas', Key: item.chaveBucket }, function(
          error,
          data,
        ) {
          if (error != null) {
            alert('Falha ao receber o objeto. ' + error.stack);
          } else {
            const url = window.URL.createObjectURL(new Blob([data.Body]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', item.chaveBucket);
            document.body.appendChild(link);
            link.click();
          }
        });
        this.updateProva(item.idProva)
      },
    },
  };
</script>
